export enum AnswerType {
  Text = 'Text',
  Choice = 'Choice',
  SmartChoice = 'SmartChoice',
}

export enum InductionQuestionTag {
  ProgressionNextStep = 'Progression next step',
  CareerReadiness = 'Career Readiness',
}

export type SmartChoice = {
  key: string
  value: number
}
